<script>
	import { onMount } from 'svelte'
	import { fade } from 'svelte/transition';
	import { useLocation } from "svelte-navigator";
	import { locale } from 'svelte-i18n'

	import LayerBg from '/components/Layers/LayerBg.svelte'
	import LayerContent from '/components/Layers/LayerContent.svelte'
	import LayerLogo from '/components/Layers/LayerLogo.svelte'
	import Layer3D from '/components/Layers/Layer3D.svelte'
	import LayerMenu from '/components/Layers/LayerMenu.svelte'
	import LayerLoader from '/components/Layers/LayerLoader.svelte'
	import LayerOverlay from '/components/Layers/LayerOverlay.svelte'
	import LayerAudioPlayer from '/components/Layers/LayerAudioPlayer.svelte'
	import LayerAlmanacLightbox from '/Layers/LayerAlmanacLightbox'
	import LayerLanguageSwitcher from '/Layers/LayerLanguageSwitcher'

	import { isCookieAccepted, scrollY, isMeditationOn, loading, isMenuActive, almanacOverlayActive, lighboxSlideActive } from '/stores.js';
	import { onAlmanacHome } from '/routes'
	import { urlsHaveSameHost } from '/helper'

	const location = useLocation();
	const loadingDuration = process.env.SHOW_PENDING ? "2s" : "5s"

	let blur, show3D, easyMenu, root
	let lateStart = false
	let neverScrolled = true
	let blackBg = false

	onMount( () => {
		root = document.documentElement

		const referrer = document.referrer
		const location = window.location

		if (urlsHaveSameHost(referrer, location)) { // skip loader
			$isCookieAccepted = true
			lateStart = true
			return
		} else {
			setTimeout(()=> lateStart = true, 1100)
		}
	})

	$: {
		root && (active => root.classList.toggle('overflowHidden', active))(
			$isMenuActive || $almanacOverlayActive || !$isCookieAccepted
		);
	}

	$: {
		blur = !$isMeditationOn && (
			(!$isCookieAccepted || $location.pathname != "/")
			|| ($location.pathname == "/" && $scrollY > 10) 
		)

		easyMenu = $scrollY <= 10

		//if (neverScrolled && $scrollY > 10) {
		//	neverScrolled = false
		//}

		blackBg = $location.pathname.match(/\/livestream$/)

		show3D = $isCookieAccepted && !$isMeditationOn && ["/", "/de"].includes($location.pathname) && $scrollY <= 10

		// console.log($isCookieAccepted, $scrollY, $location.pathname, $isMeditationOn)
	}

	$: {
		$location; 

		const germanPath = $location.pathname.match(/^\/de(\/|$)/) !== null
		$locale = germanPath ? "de" : "en"
		//if (!almanacOverlayActive) window.scrollTo(0,0)
		
		//console.log("render")
	}

</script>

<svelte:window bind:scrollY={$scrollY}/>

<!--
<LayerBg zIndex="0" playing/>

<LayerBg zIndex="1" {blur} playing={!$isMenuActive && ($isMeditationOn || (neverScrolled && $location.pathname == "/"))}/>
-->

<LayerBg zIndex="1" {blur} black={blackBg} playing={$isMeditationOn || !$isCookieAccepted}/>
<LayerMenu zIndex="30" easy={easyMenu} initial={!$isCookieAccepted} />

{#if !$isMeditationOn}	
	{#if $isCookieAccepted}
		<LayerLogo zIndex="40" initial={!$isCookieAccepted} />
		{#if onAlmanacHome($location.pathname)}
			<LayerLanguageSwitcher zIndex="40" />
		{/if}
	{/if}
	{#if lateStart}
		<LayerContent zIndex="10" hidden={ !$isCookieAccepted || $isMeditationOn }/>
		<LayerOverlay zIndex="60" />
		{#if $lighboxSlideActive !== null}
			<LayerAlmanacLightbox zIndex="90"/>
		{/if}
		<LayerAudioPlayer zIndex="70" />
		<Layer3D zIndex={80} show={show3D}/>
	{/if}
{/if}

{#if !$isCookieAccepted}
	<LayerLoader zIndex="50" {loadingDuration} />
{/if}
